import $ from "jquery";
import { Link } from 'react-router-dom';
import Booking from './Booking.js';
import OfferSliderHome from './OfferSliderHome.js';
import Testimonials from './Testimonials.js';
import Readmorehome from './Readmorehome.js';


export default function Home() {

  $('.moreless-button').on('click', function() {
    $('.moretext').slideToggle();
    if ($('.moreless-button').text() == "Read less") {
      $(this).text("Read more")
    } else {
      $(this).text("Read less")
    }
  });

    return (
      <>
        <section className="hero-sec">
      
      <div id="carouselExampleCaptions" className="carousel slide">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src="img/about-gal-1.webp" className="d-block w-100" alt="..." />
            <div className="carousel-caption d-flex flex-column h-100 justify-content-center bottom-0">
              <p className="h4 hero-title-1">Unforgettable Experiences.</p>
              <p className="h4 hero-title-2">Unmatched Curatons</p>
              <p className="hero-title-3">Because you deserve the best, especially when you stay with us.</p>
              <div className="banner-cta-buttons">
                <a href="#" className="btn explore-more-hero" data-bs-toggle="modal" data-bs-target="#exampleModal">Explore More</a>
                <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
              </div>
            </div>
          </div>

          <div className="carousel-item">
            <img src="img/banner-slide-2.webp" className="d-block w-100" alt="..." />
            <div className="carousel-caption d-flex flex-column h-100 justify-content-center bottom-0">
              <p className="h4 hero-title-1">Unforgettable Experiences.</p>
              <p className="h4 hero-title-2">Unmatched Curatons</p>
              <p className="hero-title-3">Because you deserve the best, especially when you stay with us.</p>
              <div className="banner-cta-buttons">
                <a href="#" className="btn explore-more-hero">Explore More</a>
                <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src="img/banner-slide-3.webp" className="d-block w-100" alt="..." />
            <div className="carousel-caption d-flex flex-column h-100 justify-content-center bottom-0">
              <p className="h4 hero-title-1">Unforgettable Experiences.</p>
              <p className="h4 hero-title-2">Unmatched Curatons</p>
              <p className="hero-title-3">Because you deserve the best, especially when you stay with us.</p>
              <div className="banner-cta-buttons">
                <a href="#" className="btn explore-more-hero">Explore More</a>
                <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Booking></Booking>
    
        <section className="home-about">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="h-about-left">
              <h6 className="top-sub-title">A Brand New Hotel</h6>
              <h1 className="about-title">Welcome to the The Grand New Delhi</h1>
              <Link to="About" className="more-about-us button">
                <p>More About us</p>
              </Link>
              
            </div>
          </div>
          <div className="col-md-6">
            <div className="about-right-content">
              <h6 className="right-sub-title">An Immersive Experience in The Heart of New Delhi</h6>
                    <Readmorehome/>
                 </div>
            </div>

            <div className="col-md-12 about-img-gallery">
              <div className="hero-right">
                  <div className="hero-left">
                      <img src="img/about-gal-1.webp" alt="" />
                  </div>
                  <div className="hero-right-inner-main">
                      <div className="hero-right-inner">
                          <img src="img/about-gal-2.webp" alt="" />
                          <img src="img/about-gal-3.webp" alt="" />
                      </div>
                      <div className="hero-right-inner hero-right-inner-last">
                          <img src="img/about-gal-4.webp" alt="" />
                          <img src="img/about-gal-5.webp" alt="" />
                      </div>
                  </div>
          
              </div>
          </div>

           
          </div>
        </div>
      </section>


<section className="accomodation-sec">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="text-box-block">
              <h4 className="text-block-title">
                Luxurious  Accommodation Near Delhi Airport
              </h4>
              <p>
                Decked in elegance and opulence, our range of premium suites, luxury rooms and grand apartments in New Delhi, resonate with an elite lifestyle. These hotel rooms near Delhi airport provide ultra comfort and are designed for
                an ideal stay in the city.
                          </p>
                
              </div>
          </div>

          <div className="col-md-8">
              <div className="offer-sec">
                <OfferSliderHome></OfferSliderHome>
              </div>
          </div>
        </div>


        </div>
      </section>

      <section className="cta-section-home">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-md-8">
        <div className="cta-box-content">
          <h3 className="cta-heading">Grand Socials & Weddings Venues<br/>
            in New Delhi at  The Grand</h3>
            <p>For all the special occasions that bring you closer to your family, friends and loved ones, weddings & socials at
              our 5-star hotel near New Delhi Airport - The Grand New Delhi, stand shoulder-to-shoulder with you at
              all your events to make it a grand success.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="home-mid-sec">
  <div className="container-fluid p-0">
    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            Grand Socials & Weddings
          </h4>
          <p>
            For all the special occasions that bring you closer to your family, friends and loved ones, weddings & socials at our
            5-star hotel near New Delhi Airport - The Grand New Delhi, stand shoulder-to-shoulder with you at all your events to make it a grand success. 
          </p>
          <div className="text-box-btns">
            <a href="#" className="btn explore-more-hero">Explore More</a>
            <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
          </div>
          
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/wedding-event.jpg" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            The Grand Ballroom
          </h4>
          <p>
            Exuding sheer luxury, the 6,500 square feet pillar-less ballroom in Vasant Kunj is known to host a diverse range of functions from corporate events, product launches, conferences, seminars to private parties, weddings, fashion shows, exhibitions and more and can easily host over 2000 guests.
          </p>
          <div className="text-box-btns">
            <a href="#" className="btn explore-more-hero">Explore More</a>
            <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/new-event-img.jpg" className="w-100" alt="wedding and events" />
        </div>
      </div>
      
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            Jade - A Conference Venue
          </h4>
          <p>
            Jade at The Grand New Delhi is a 1,700 square feet hall in Vasant Kunj with plush interiors and modern facilities. With a capacity to hold up to 100 people in theatre formation, this conference hall in New Delhi is a perfect venue for corporate events.
          </p>
          <div className="text-box-btns">
            <a href="#" className="btn explore-more-hero">Explore More</a>
            <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/conference-venue.jpg" className="w-100" alt="wedding and events" />
        </div>
      </div>
      
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title"> Board Room - A Meeting Venue in New Delhi </h4>
          <p>
            The Board Room at The Grand New Delhi has been designed keeping in mind the needs of the modern day business meeting. The meeting hall in Vasant Kunj is equipped with all contemporary amenities, high-speed internet and  conference facility. This boardroom is one of the finest meeting venues in New Delhi. 
          </p>
          <div className="text-box-btns">
            <a href="#" className="btn explore-more-hero">Explore More</a>
            <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/board-room.jpg" className="w-100" alt="wedding and events" />
        </div>
      </div>
      
    </div>


  </div>
</section>


<Testimonials></Testimonials>

<div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div className="modal-dialog">
              <div className="modal-content">
                  <div className="modal-body">
                      <h5 className="modal-title">Enquire Now</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      <div className="fixed-form fixed">
                          <form method="post" action="#">
                              <div className="form row">
                                  <div className="col-12 form-group">
                                      <input type="text" className="form-control" id="" name="name" placeholder="First Name*" required />
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="text" className="form-control" id="" name="name" placeholder="Last Name*" required />
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="phone" className="form-control" name="phone" id="" placeholder="Phone*" required/>
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="email" className="form-control" name="email" id="" placeholder="Email*" required />
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="text" className="form-control" id="checkindate" placeholder="Checkin" name="fromdate" readonly="" />
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="text" className="form-control" id="checkoutdate" placeholder="Checkout" name="fromdate" readonly="" />
                                  </div>
                                  
                                  <div className="col-12 form-group">
                                      <select className="form-select form-control" aria-label="Default select example">
                                        <option selected disabled>Please Select</option>
                                        <option value="Studio Apartment">Studio Apartment</option>
                                        <option value="1 BHK Apartment">1 BHK Apartment</option>
                                      </select>
                                  </div>

                                  <div className="col-12 form-group">
                                      <textarea className="form-control" placeholder="Message" rows="3" required></textarea>
                                  </div>
                                 
                                  <div className="col-12 formFooter">
                                      <button type="submit" name="Submit" value="Submit" className="btn mx-auto">Submit</button>
                                  </div>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
</div>



      </>
    );
  }
  